import { useEffect, useState } from 'react';
import { formatDate, getCalendarDates, getMonthName } from '../lib/date';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

const weeks = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const Calendar = ({
  selectedDate,
  selectDate = null,
  children,
  handleMonthChange = null,
}) => {
  const [currentYear, setCurrentYear] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [calendar, setCalendar] = useState(null);
  const [onDate, setOnDate] = useState(null);

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    setCurrentYear(year);
    setCurrentMonth(month);
    setCalendar(getCalendarDates(year, month));
  }, []);

  useEffect(() => {
    if (onDate && selectDate) {
      selectDate(onDate);
    }
  }, [onDate]);

  const handlePrevMonth = () => {
    if (currentMonth > 1) {
      setCurrentMonth(currentMonth - 1);
      setCalendar(getCalendarDates(currentYear, currentMonth - 1));
    }
    if (currentMonth === 1) {
      setCurrentYear(currentYear - 1);
      setCurrentMonth(12);
      setCalendar(getCalendarDates(currentYear - 1, 12));
    }
    if (handleMonthChange) {
      handleMonthChange(currentYear, currentMonth);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth < 12) {
      setCurrentMonth(currentMonth + 1);
      setCalendar(getCalendarDates(currentYear, currentMonth + 1));
    }
    if (currentMonth === 12) {
      setCurrentYear(currentYear + 1);
      setCurrentMonth(1);
      setCalendar(getCalendarDates(currentYear + 1, 1));
    }
    if (handleMonthChange) {
      handleMonthChange(currentYear, currentMonth);
    }
  };

  const handleSelectDate = (date) => () => {
    setOnDate(date);
  };

  return (
    calendar && (
      <div>
        {Object.entries(calendar).map(([year, months]) => (
          <div key={year}>
            {Object.entries(months).map(([month, dates]) => (
              <div
                key={month}
                className='bg-secondary rounded-2xl p-6'
              >
                <div className='text-white mb-4 max-w-sm flex flex-col gap-2 mx-auto'>
                  <div className='font-bold'>
                    <div className='text-xs'>{year}</div>
                  </div>
                  <div className='flex items-center justify-between gap-2'>
                    <button
                      className='text-white'
                      onClick={handlePrevMonth}
                    >
                      <ChevronLeftIcon className='size-5' />
                    </button>
                    <div className='font-bold text-lg'>
                      {getMonthName(month)}
                    </div>
                    <button
                      className='text-white'
                      onClick={handleNextMonth}
                    >
                      <ChevronRightIcon className='size-5' />
                    </button>
                  </div>
                </div>
                <div className='grid grid-cols-7 gap-2 text-sm font-medium mb-2'>
                  {weeks.map((week, i) => (
                    <div
                      key={i}
                      className='flex justify-center items-center text-gray-400'
                    >
                      {week}
                    </div>
                  ))}
                </div>
                <div className='grid grid-cols-7'>
                  {dates.map((date, i) => (
                    <div
                      key={i}
                      onClick={
                        date && handleSelectDate(`${year}-${month}-${date}`)
                      }
                    >
                      <div
                        className={`
                          relative h-10 rounded-lg flex justify-center items-center transition-all
                          ${date ? 'cursor-pointer' : ''}
                          `}
                      >
                        <span
                          className={`text-sm size-8 rounded-lg flex justify-center items-center ${
                            selectedDate === `${year}-${month}-${date}`
                              ? 'bg-white text-neutral-900'
                              : `${year}-${month}-${date}` ===
                                formatDate(new Date())
                              ? 'ring-1 ring-neutral-700 bg-neutral-800 text-white'
                              : 'text-gray-300'
                          }`}
                        >
                          {date?.[0] === '0' ? date[1] : date}
                        </span>
                        {children}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    )
  );
};

export default Calendar;
